export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const USER_TYPE = "USER_TYPE";
export const UPDATE_USER_TYPE = "UPDATE_USER_TYPE";

export const SHOW_NOTIFICATION_DIALOG = "SHOW_NOTIFICATION_DIALOG";
export const HIDE_NOTIFICATION_DIALOG = "HIDE_NOTIFICATION_DIALOG";

export const GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_ERROR = "GET_CUSTOMER_ERROR";

export const GET_LOCATION_REQUEST = "GET_LOCATION_REQUEST";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_ERROR = "GET_LOCATION_ERROR";
export const CLEAR_LOCATION_REQUEST = "CLEAR_LOCATION_REQUEST";

export const SHOW_NOTIFICATION_DIALOG_EMERGENCY_0RDER =
  "SHOW_NOTIFICATION_DIALOG_EMERGENCY_0RDER";
export const HIDE_NOTIFICATION_DIALOG_EMERGENCY_0RDER =
  "HIDE_NOTIFICATION_DIALOG_EMERGENCY_0RDER";

export const UPLOAD_EMERGENCY_ORDER_REQUEST = "UPLOAD_EMERGENCY_ORDER_REQUEST";
export const UPLOAD_EMERGENCY_ORDER_SUCCESS = "UPLOAD_EMERGENCY_ORDER_SUCCESS";
export const UPLOAD_EMERGENCY_ORDER_ERROR = "UPLOAD_EMERGENCY_ORDER_ERROR";
export const RESET_UPLOAD_EMERGENCY_ORDER = "RESET_UPLOAD_EMERGENCY_ORDER";
export const RESET_UPLOAD_EMERGENCY_ERROR = "RESET_UPLOAD_EMERGENCY_ERROR";

export const GET_MANUAL_ORDER_REQUEST = "GET_MANUAL_ORDER_REQUEST";
export const GET_MANUAL_ORDER_SUCCESS = "GET_MANUAL_ORDER_SUCCESS";
export const GET_MANUAL_ORDER_ERROR = "GET_MANUAL_ORDER_ERROR";
export const GET_MANUAL_ORDER_RESET = "GET_MANUAL_ORDER_RESET";

export const GET_MANUAL_ORDER_SUCCESS_DOWNLOAD =
  "GET_MANUAL_ORDER_SUCCESS_DOWNLOAD";
export const GET_MANUAL_ORDER_ERROR_DOWNLOAD =
  "GET_MANUAL_ORDER_ERROR_DOWNLOAD";
export const GET_MANUAL_ORDER_REQUEST_DOWNLOAD =
  "GET_MANUAL_ORDER_REQUEST_DOWNLOAD";
export const CLEAR_CSV_DATA = "CLEAR_CSV_DATA";
export const GET_MANUAL_ORDER_RESET_DOWNLOAD =
  "GET_MANUAL_ORDER_RESET_DOWNLOAD";

export const GET_MANUAL_ORDER_AUDIT_REQUEST_DOWNLOAD =
  "GET_MANUAL_ORDER_AUDIT_REQUEST_DOWNLOAD";
export const GET_MANUAL_ORDER_AUDIT_SUCCESS_DOWNLOAD =
  "GET_MANUAL_ORDER_AUDIT_SUCCESS_DOWNLOAD";
export const GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD =
  "GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD";
export const CLEAR_AUDIT_DATA = "CLEAR_AUDIT_DATA";
export const GET_MANUAL_ORDER_AUDIT_RESET_DOWNLOAD =
  "GET_MANUAL_ORDER_AUDIT_RESET_DOWNLOAD";

export const FETCH_AUDIT_ORDERS_REQUEST = "FETCH_AUDIT_ORDERS_REQUEST";
export const FETCH_AUDIT_ORDERS_SUCCESS = "FETCH_AUDIT_ORDERS_SUCCESS";
export const FETCH_AUDIT_ORDERS_FAILURE = "FETCH_AUDIT_ORDERS_FAILURE";
export const FETCH_AUDIT_ORDERS_RESET = "FETCH_AUDIT_ORDERS_RESET";

export const GET_AMEND_MANUAL_ORDERS_REQUEST =
  "GET_AMEND_MANUAL_ORDERS_REQUEST";
export const GET_AMEND_MANUAL_ORDERS_SUCCESS =
  "GET_AMEND_MANUAL_ORDERS_SUCCESS";
export const GET_AMEND_MANUAL_ORDERS_ERROR = "GET_AMEND_MANUAL_ORDERS_ERROR";
export const RESET_AMEND_MAUAL_ORDERS = "RESET_AMEND_MAUAL_ORDERS";
export const UPDATE_AMEND_MANUAL_ORDERS = "UPDATE_AMEND_MANUAL_ORDERS";

export const PROCESS_ORDERS_REQUEST = "PROCESS_ORDERS_REQUEST";
export const PROCESS_ORDERS_SUCCESS = "PROCESS_ORDERS_SUCCESS";
export const PROCESS_ORDERS_ERROR = "PROCESS_ORDERS_ERROR";
export const RESET_PROCESS_ORDERS = "RESET_PROCESS_ORDERS";

export const GET_APPROVAL_ORDER_REQUEST = "GET_APPROVAL_ORDER_REQUEST";
export const GET_APPROVAL_ORDER_SUCCESS = "GET_APPROVAL_ORDER_SUCCESS";
export const GET_APPROVAL_ORDER_ERROR = "GET_APPROVAL_ORDER_ERROR";
export const RESET_APPROVAL_ORDER = "RESET_APPROVAL_ORDER";
export const UPDATE_APPROVAL_ORDER = "UPDATE_APPROVAL_ORDER";

export const ORDEROPPORTUNITIES_MANUAL_ORDER_REQUEST =
  "ORDEROPPORTUNITIES_MANUAL_ORDER_REQUEST";
export const ORDEROPPORTUNITIES_MANUAL_ORDER_SUCCESS =
  "ORDEROPPORTUNITIES_MANUAL_ORDER_SUCCESS";
export const ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR =
  "ORDEROPPORTUNITIES_MANUAL_ORDER_ERROR";
export const RESET_ORDEROPPORTUNITIES_MANUAL_ORDER =
  "RESET_ORDEROPPORTUNITIES_MANUAL_ORDER";

export const CREATE_MANUAL_ORDERS_REQUEST = "CREATE_MANUAL_ORDERS_REQUEST";
export const CREATE_MANUAL_ORDERS_SUCCESS = "CREATE_MANUAL_ORDERS_SUCCESS";
export const CREATE_MANUAL_ORDERS_ERROR = "CREATE_MANUAL_ORDERS_ERROR";
export const RESET_CREATE_MANUAL_ORDER = "RESET_CREATE_MANUAL_ORDER";
export const RESET_CREATE_MANUAL_ORDER_ERROR =
  "RESET_CREATE_MANUAL_ORDER_ERROR";

export const GET_GOLDEN_STORE_REQUEST = "GET_GOLDEN_STORE_REQUEST";
export const GET_GOLDEN_STORE_SUCCESS = "GET_GOLDEN_STORE_SUCCESS";
export const GET_GOLDEN_STORE_FAILURE = "GET_GOLDEN_STORE_FAILURE";

export const GET_GOLDEN_STORE_SEARCH_REQUEST =
  "GET_GOLDEN_STORE_SEARCH_REQUEST";
export const GET_GOLDEN_STORE_SEARCH_SUCCESS =
  "GET_GOLDEN_STORE_SEARCH_SUCCESS";
export const GET_GOLDEN_STORE_SEARCH_FAILURE =
  "GET_GOLDEN_STORE_SEARCH_FAILURE";
export const RESET_SEARCH_RESULT = "RESET_SEARCH_RESULT";

export const ADD_GOLDEN_STORE_REQUEST = "ADD_GOLDEN_STORE_REQUEST";
export const ADD_GOLDEN_STORE_SUCCESS = "ADD_GOLDEN_STORE_SUCCESS";
export const ADD_GOLDEN_STORE_FAILURE = "ADD_GOLDEN_STORE_FAILURE";
export const ADD_GOLDEN_STORE_RESET = "ADD_GOLDEN_STORE_RESET";

export const GET_REASON_CODES_REQUEST = "GET_REASON_CODES_REQUEST";
export const GET_REASON_CODES_SUCCESS = "GET_REASON_CODES_SUCCESS";
export const GET_REASON_CODES_ERROR = "GET_REASON_CODES_ERROR";
export const CLEAR_REASON_CODES_REQUEST = "CLEAR_REASON_CODES_REQUEST";

export const UPLOAD_MANUAL_ORDER_REQUEST = "UPLOAD_MANUAL_ORDER_REQUEST";
export const UPLOAD_MANUAL_ORDER_SUCCESS = "UPLOAD_MANUAL_ORDER_SUCCESS";
export const UPLOAD_MANUAL_ORDER_ERROR = "UPLOAD_MANUAL_ORDER_ERROR";
export const RESET_UPLOAD_MANUAL_ORDER = "RESET_UPLOAD_MANUAL_ORDER";
export const RESET_UPLOAD_MANUAL_ERROR = "RESET_UPLOAD_MANUAL_ERROR";

export const SHOW_NOTIFICATION_DIALOG_MANUAL_0RDER =
  "SHOW_NOTIFICATION_DIALOG_MANUAL_0RDER";
export const HIDE_NOTIFICATION_DIALOG_MANUAL_0RDER =
  "HIDE_NOTIFICATION_DIALOG_MANUAL_0RDER";

export const GET_CUTOFF_TIME_REQUEST = "GET_CUTOFF_TIME_REQUEST";
export const GET_CUTOFF_TIME_SUCCESS = "GET_CUTOFF_TIME_SUCCESS";
export const GET_CUTOFF_TIME_ERROR = "GET_CUTOFF_TIME_ERROR";
export const CLEAR_CUTOFF_TIME_REQUEST = "CLEAR_CUTOFF_TIME_REQUEST";

export const GET_ROLES_REQUEST = "GET_ROLES_REQUEST";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "GET_ROLES_FAILURE";

export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const GET_USER_RESET = "GET_USER_RESET";

export const UPDATE_USER_ROLE_REQUEST = "UPDATE_USER_ROLE_REQUEST";
export const UPDATE_USER_ROLE_SUCCESS = "UPDATE_USER_ROLE_SUCCESS";
export const UPDATE_USER_ROLE_FAILURE = "UPDATE_USER_ROLE_FAILURE";

export const UPDATE_USER_ROLE_RESET = "UPDATE_USER_ROLE_RESET";

export const CREATE_PROCESS_ORDERS_REQUEST = "CREATE_PROCESS_ORDERS_REQUEST";
export const CREATE_PROCESS_ORDERS_SUCCESS = "CREATE_PROCESS_ORDERS_SUCCESS";
export const CREATE_PROCESS_ORDERS_ERROR = "CREATE_PROCESS_ORDERS_ERROR";
export const RESET_CREATE_PROCESS_ORDERS = "RESET_CREATE_PROCESS_ORDERS";

export const GET_STORE_CATALOGUE_REQUEST = "GET_STORE_CATALOGUE_REQUEST";
export const GET_STORE_CATALOGUE_SUCCESS = "GET_STORE_CATALOGUE_SUCCESS";
export const GET_STORE_CATALOGUE_FAILURE = "GET_STORE_CATALOGUE_FAILURE";

export const SEARCH_ORDEROPPORTUNITIES_REQUEST =
  "SEARCH_ORDEROPPORTUNITIES_REQUEST";
export const SEARCH_ORDEROPPORTUNITIES_SUCCESS =
  "SEARCH_ORDEROPPORTUNITIES_SUCCESS";
export const SEARCH_ORDEROPPORTUNITIES_ERROR =
  "SEARCH_ORDEROPPORTUNITIES_ERROR";
export const SEARCH_ORDEROPPORTUNITIES_RESET =
  "SEARCH_ORDEROPPORTUNITIES_RESET";

export const SHOW_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD =
  "SHOW_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD";
export const HIDE_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD =
  "HIDE_NOTIFICATION_DIALOG_MANUAL_PO_UPLOAD";
export const SHOW_SECOND_DIALOG = "SHOW_SECOND_DIALOG";

//Supplier Purchase Order
export const UPLOAD_PURCHASE_ORDER_REQUEST = "UPLOAD_PURCHASE_ORDER_REQUEST";
export const UPLOAD_PURCHASE_ORDER_SUCCESS = "UPLOAD_PURCHASE_ORDER_SUCCESS";
export const UPLOAD_PURCHASE_ORDER_ERROR = "UPLOAD_PURCHASE_ORDER_ERROR";
export const RESET_UPLOAD_PURCHASE_ORDER = "RESET_UPLOAD_PURCHASE_ORDER";

export const MANUAL_PO_LIFECYCLE_REQUEST = "MANUAL_PO_LIFECYCLE_REQUEST";
export const MANUAL_PO_LIFECYCLE_SUCCESS = "MANUAL_PO_LIFECYCLE_SUCCESS";
export const MANUAL_PO_LIFECYCLE_ERROR = "MANUAL_PO_LIFECYCLE_ERROR";
export const RESET_MANUAL_PO_LIFECYCLE = "RESET_MANUAL_PO_LIFECYCLE";

export const CREATE_PURCHASE_ORDERS_REQUEST = "CREATE_PURCHASE_ORDERS_REQUEST";
export const CREATE_PURCHASE_ORDERS_SUCCESS = "CREATE_PURCHASE_ORDERS_SUCCESS";
export const CREATE_PURCHASE_ORDERS_ERROR = "CREATE_PURCHASE_ORDERS_ERROR";
export const RESET_CREATE_PURCHASE_ORDER = "RESET_CREATE_PURCHASE_ORDER";

export const MANUAL_PO_ENQUIRY_REQUEST = "MANUAL_PO_ENQUIRY_REQUEST";
export const MANUAL_PO_ENQUIRY_SUCCESS = "MANUAL_PO_ENQUIRY_SUCCESS";
export const MANUAL_PO_ENQUIRY_ERROR = "MANUAL_PO_ENQUIRY_ERROR";
export const RESET_MANUAL_PO_ENQUIRY = "RESET_MANUAL_PO_ENQUIRY";

export const GET_SUPPLIERS_REQUEST = "GET_SUPPLIERS_REQUEST";
export const GET_SUPPLIERS_SUCCESS = "GET_SUPPLIERS_SUCCESS";
export const GET_SUPPLIERS_FAILURE = "GET_SUPPLIERS_FAILURE";
export const GET_SUPPLIERS_RESET = "GET_SUPPLIERS_RESET";

export const SEARCH_PO_REQUEST = "SEARCH_PO_REQUEST";
export const SEARCH_PO_SUCCESS = "SEARCH_PO_SUCCESS";
export const SEARCH_PO_FAILURE = "SEARCH_PO_FAILURE";
export const SEARCH_PO_RESET = "SEARCH_PO_RESET";

export const PO_AMEND_PATCH_REQUEST = "PO_AMEND_PATCH_REQUEST";
export const PO_AMEND_PATCH_SUCCESS = "PO_AMEND_PATCH_SUCCESS";
export const PO_AMEND_PATCH_ERROR = "PO_AMEND_PATCH_ERROR";
export const RESET_PO_AMEND_PATCH = "RESET_PO_AMEND_PATCH";

export const PO_SEARCH_OPPORTUNITIES_REQUEST = "PO_SEARCH_OPPORTUNITIES_REQUEST";
export const PO_SEARCH_OPPORTUNITIES_SUCCESS = "PO_SEARCH_OPPORTUNITIES_SUCCESS";
export const PO_SEARCH_OPPORTUNITIES_ERROR = "PO_SEARCH_OPPORTUNITIES_ERROR";
export const PO_SEARCH_OPPORTUNITIES_RESET = "PO_SEARCH_OPPORTUNITIES_RESET";

export const SEARCH_DNO_REQUEST = "SEARCH_DNO_REQUEST";
export const SEARCH_DNO_SUCCESS = "SEARCH_DNO_SUCCESS";
export const SEARCH_DNO_FAILURE = "SEARCH_DNO_FAILURE";
export const SEARCH_DNO_RESET = "SEARCH_DNO_RESET";

export const ADD_DNO_ITEMS_REQUEST = "ADD_DNO_ITEMS_REQUEST";
export const ADD_DNO_ITEMS_SUCCESS = "ADD_DNO_ITEMS_SUCCESS";
export const ADD_DNO_ITEMS_FAILURE = "ADD_DNO_ITEMS_FAILURE";
export const ADD_DNO_ITEMS_RESET = "ADD_DNO_ITEMS_RESET";

export const REMOVE_DNO_ITEMS_REQUEST = "REMOVE_DNO_ITEMS_REQUEST";
export const REMOVE_DNO_ITEMS_SUCCESS = "REMOVE_DNO_ITEMS_SUCCESS";
export const REMOVE_DNO_ITEMS_FAILURE = "REMOVE_DNO_ITEMS_FAILURE";
export const REMOVE_DNO_ITEMS_RESET = "REMOVE_DNO_ITEMS_RESET";

export const SEARCH_SUPPLIER_DESTINATION_MAPPING_REQUEST = "SEARCH_SUPPLIER_DESTINATION_MAPPING_REQUEST";
export const SEARCH_SUPPLIER_DESTINATION_MAPPING_SUCCESS = "SEARCH_SUPPLIER_DESTINATION_MAPPING_SUCCESS";
export const SEARCH_SUPPLIER_DESTINATION_MAPPING_FAILURE = "SEARCH_SUPPLIER_DESTINATION_MAPPING_FAILURE";
export const SEARCH_SUPPLIER_DESTINATION_MAPPING_RESET = "SEARCH_SUPPLIER_DESTINATION_MAPPING_RESET";

export const ADD_SUPPLIER_DESTINATION_MAPPING_REQUEST = "ADD_SUPPLIER_DESTINATION_MAPPING_REQUEST";
export const ADD_SUPPLIER_DESTINATION_MAPPING_SUCCESS = "ADD_SUPPLIER_DESTINATION_MAPPING_SUCCESS";
export const ADD_SUPPLIER_DESTINATION_MAPPING_FAILURE = "ADD_SUPPLIER_DESTINATION_MAPPING_FAILURE";
export const ADD_SUPPLIER_DESTINATION_MAPPING_RESET = "ADD_SUPPLIER_DESTINATION_MAPPING_RESET";

export const REMOVE_SUPPLIER_DESTINATION_MAPPING_REQUEST = "REMOVE_SUPPLIER_DESTINATION_MAPPING_REQUEST";
export const REMOVE_SUPPLIER_DESTINATION_MAPPING_SUCCESS = "REMOVE_SUPPLIER_DESTINATION_MAPPING_SUCCESS";
export const REMOVE_SUPPLIER_DESTINATION_MAPPING_FAILURE = "REMOVE_SUPPLIER_DESTINATION_MAPPING_FAILURE";
export const REMOVE_SUPPLIER_DESTINATION_MAPPING_RESET = "REMOVE_SUPPLIER_DESTINATION_MAPPING_RESET";

export const DOWNLOAD_MAX_CAP_REPORT_REQUEST = "DOWNLOAD_MAX_CAP_REPORT_REQUEST";
export const DOWNLOAD_MAX_CAP_REPORT_SUCCESS = "DOWNLOAD_MAX_CAP_REPORT_SUCCESS";
export const DOWNLOAD_MAX_CAP_REPORT_FAILURE = "DOWNLOAD_MAX_CAP_REPORT_FAILURE";
export const DOWNLOAD_MAX_CAP_REPORT_RESET = "DOWNLOAD_MAX_CAP_REPORT_RESET";

export const BULK_DELETE_MAX_CAP_REQUEST = "BULK_DELETE_MAX_CAP_REQUEST";
export const BULK_DELETE_MAX_CAP_SUCCESS = "BULK_DELETE_MAX_CAP_SUCCESS";
export const BULK_DELETE_MAX_CAP_FAILURE = "BULK_DELETE_MAX_CAP_FAILURE";
export const BULK_DELETE_MAX_CAP_RESET = "BULK_DELETE_MAX_CAP_RESET";

export const SEARCH_MAX_CAP_REQUEST = "SEARCH_MAX_CAP_REQUEST";
export const SEARCH_MAX_CAP_SUCCESS = "SEARCH_MAX_CAP_SUCCESS";
export const SEARCH_MAX_CAP_FAILURE = "SEARCH_MAX_CAP_FAILURE";
export const SEARCH_MAX_CAP_RESET = "SEARCH_MAX_CAP_RESET";

export const ADD_MAX_CAP_REQUEST = "ADD_MAX_CAP_REQUEST";
export const ADD_MAX_CAP_SUCCESS = "ADD_MAX_CAP_SUCCESS";
export const ADD_MAX_CAP_FAILURE = "ADD_MAX_CAP_FAILURE";
export const ADD_MAX_CAP_RESET = "ADD_MAX_CAP_RESET";

export const BULK_UPDATE_MAX_CAP_REQUEST = "BULK_UPDATE_MAX_CAP_REQUEST";
export const BULK_UPDATE_MAX_CAP_SUCCESS = "BULK_UPDATE_MAX_CAP_SUCCESS";
export const BULK_UPDATE_MAX_CAP_FAILURE = "BULK_UPDATE_MAX_CAP_FAILURE";
export const BULK_UPDATE_MAX_CAP_RESET = "BULK_UPDATE_MAX_CAP_RESET";

export const UPDATE_SELECTED_MAX_CAP_REQUEST = "UPDATE_SELECTED_MAX_CAP_REQUEST";
export const UPDATE_SELECTED_MAX_CAP_SUCCESS = "UPDATE_SELECTED_MAX_CAP_SUCCESS";
export const UPDATE_SELECTED_MAX_CAP_FAILURE = "UPDATE_SELECTED_MAX_CAP_FAILURE";
export const UPDATE_SELECTED_MAX_CAP_RESET = "UPDATE_SELECTED_MAX_CAP_RESET";

export const UPLOAD_RECEIPT_FILE_REQUEST = "UPLOAD_RECEIPT_FILE_REQUEST";
export const UPLOAD_RECEIPT_FILE_SUCCESS = "UPLOAD_RECEIPT_FILE_SUCCESS";
export const UPLOAD_RECEIPT_FILE_ERROR = "UPLOAD_RECEIPT_FILE_ERROR";
export const RESET_UPLOAD_RECEIPT_FILE = "RESET_UPLOAD_RECEIPT_FILE";

export const GET_PO_CONFIG_REQUEST = "GET_PO_CONFIG_REQUEST";
export const GET_PO_CONFIG_SUCCESS = "GET_PO_CONFIG_SUCCESS";
export const GET_PO_CONFIG_ERROR = "GET_PO_CONFIG_ERROR";